import { Component, OnInit, Input, inject } from '@angular/core';
import { IComponentSection } from '../../../interfaces/component-section';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { SharedService } from '../../../services/shared.service';
import { BrandService } from '../../../services/brand/brand.service';
//import { ThemeDirective } from '../../../directives/theme.directive';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-brand-header-image-only',
    standalone: true,
    templateUrl: './brand-header-image-only.component.html',
    styleUrls: ['./brand-header-image-only.component.css'],
    //imports: [ThemeDirective]
})
export class BrandHeaderImageOnlyComponent implements OnInit, IComponentSection {

  @Input() data: any;
  @Input() additionalParams?: Map<string,any>;

  private readonly logger = inject(NGXLogger);  
  private readonly sharedService = inject(SharedService);
  private readonly brandService = inject(BrandService);

  brandLogoImage!: any;
  isBrandLogoImageShown: boolean = false;

  public current = {};
  brandStyleTheme: any = {};
  // brandStyleTheme: {[key: string]: string} = {}

  imageHeight: number = 150;

  constructor(
  ) { }

  ngOnInit(): void {
    this.makeBrandHeader(this.data);
  }

  makeBrandHeader (brandInfo: IBrandInfo) {
    this.brandStyleTheme = brandInfo.brandStyleTheme;
    // Display the brand logo image, if possible
    this.brandLogoImage = null;
    this.isBrandLogoImageShown = false;
    this.logger.log(`BrandHeaderImageOnlyComponent - makeBrandHeader: brandInfo: ${brandInfo}`);    
    this.logger.log(`BrandHeaderImageOnlyComponent - makeBrandHeader: brandLogoImageUrl: ${brandInfo.brandLogoImageUrl}`);    
    this.getBrandImage(brandInfo.brandLogoImageUrl);
    // if (brandInfo.imageDescr) {
    //   this.brandLogoImage = 'data:' + brandInfo.imageDescr.imageType + ';base64,' + brandInfo.imageDescr.imageContent;
    //   this.isBrandLogoImageShown = true;
    // }

    if (this.additionalParams) {
      if (this.additionalParams.has('useNonmobileBrandImage')) {
        let useNonmobileBrandImage: boolean = Boolean(this.additionalParams.get('useNonmobileBrandImage'));
        if (useNonmobileBrandImage) {
          this.logger.log(`BrandHeaderImageOnlyComponent - makeBrandHeader: nonmobileImageUrl: ${brandInfo.nonmobileImageUrl}`);    
          this.getBrandImage(brandInfo.nonmobileImageUrl);
          let nonmobileImageHeight = this.sharedService.getBrandConfigProperty(brandInfo, "WAL_PAGES_NONMOBILE_IMAGE_HEIGHT");
          if (nonmobileImageHeight) {
            this.imageHeight = Number(nonmobileImageHeight);
          }
        }
      }
    }

  }

  private getBrandImage(imageUrl: string | undefined) {
  if (imageUrl) {
    this.brandService.getImageByUrl(imageUrl)
      .subscribe({
        next: (response) => {
          const reader = new FileReader();
          reader.onload = () => {
            this.brandLogoImage = reader.result as string;
          };
          reader.readAsDataURL(response);
        },
        error: (error) => {
        },
        complete: () => {
        }
      });
    }
  }

}
